import React from "react";
import styles from "../styles/styles";
import { getCategoryColor } from "../util/categoryColor";
export default function PantographMatrix({

    cars = [],
    matrixData = {},
    categoryLabel = "Pantógrafo"

}) {

    return (
        <div style={styles.pantographWrapper}>

            <table style={styles.pantographTable}>

                <thead>
                    <tr>

                        <th style={{ width: "40px" }}></th>

                        <th style={{ width: "180px" }}></th>

                    </tr>
                </thead>

                <tbody>
                    <tr>

                        <td style={styles.pantographVertical}>
                            {categoryLabel}
                        </td>

                        <td style={styles.pantographLabel}></td>

                        {cars.map(car => {

                            const data =
                                matrixData?.[car] ?? {};
                            if (!data.possuiPantografo) {
                                return (
                                    <td
                                        key={car}
                                        style={styles.pantographCell}
                                    />
                                );
                            }

                            return (

                                <td
                                    key={car}
                                    style={styles.pantographCell}
                                >

                                    <div style={styles.pantographStack}>

                                        {/* ÍCONES */}
                                        <div style={styles.pantographIconRow}>
                                            {(data.inverterPantografos
                                                ? [
                                                    { levantado: data.levantado2, abaixado: data.abaixado2 },
                                                    { levantado: data.levantado, abaixado: data.abaixado }
                                                ]
                                                : [
                                                    { levantado: data.levantado, abaixado: data.abaixado },
                                                    { levantado: data.levantado2, abaixado: data.abaixado2 }
                                                ]
                                            ).map((p, idx) => (
                                                <div style={styles.pantographGroup} key={idx}>
                                                    <div
                                                        style={
                                                            p.levantado
                                                                ? styles.pantographTriangleUpGreen
                                                                : styles.pantographTriangleUp
                                                        }
                                                    />
                                                    <div
                                                        style={
                                                            p.abaixado
                                                                ? styles.pantographTriangleDownRed
                                                                : styles.pantographTriangleDown
                                                        }
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                        <div>
                                            <div style={styles.pantographStatusContainer}>
                                                {(data.inverterPantografos
                                                    ? [
                                                        { isolado: data.isolado2, isoladoCategory: data.isolado2Category, falha: data.falha2, falhaCategory: data.falha2Category },
                                                        { isolado: data.isolado, isoladoCategory: data.isoladoCategory, falha: data.falha, falhaCategory: data.falhaCategory }
                                                    ]
                                                    : [
                                                        { isolado: data.isolado, isoladoCategory: data.isoladoCategory, falha: data.falha, falhaCategory: data.falhaCategory },
                                                        { isolado: data.isolado2, isoladoCategory: data.isolado2Category, falha: data.falha2, falhaCategory: data.falha2Category }
                                                    ]
                                                ).map((p, idx) => (
                                                    <div style={styles.pantographGroup} key={idx}>

                                                        <div
                                                            style={{
                                                                ...styles.pantographBox,
                                                                background:
                                                                    p.isolado
                                                                        ? (
                                                                            getCategoryColor(
                                                                                p.isoladoCategory
                                                                            ) || "#ef4444"
                                                                        )
                                                                        : "#ffffff",
                                                                color:
                                                                    p.isolado
                                                                        ? "#ffffff"
                                                                        : "#000000"
                                                            }}
                                                        >
                                                            ISOLADO
                                                        </div>

                                                        <div
                                                            style={{
                                                                ...styles.pantographBox,
                                                                background:
                                                                    p.falha
                                                                        ? (
                                                                            getCategoryColor(
                                                                                p.falhaCategory
                                                                            ) || "#ef4444"
                                                                        )
                                                                        : "#ffffff",
                                                                color:
                                                                    p.falha
                                                                        ? "#ffffff"
                                                                        : "#000000"
                                                            }}
                                                        >
                                                            FALHA
                                                        </div>

                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                    </div>

                                </td>
                            );
                        })}

                    </tr>
                </tbody>

            </table>

        </div>
    );
}